import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SessionService } from '../../_services/session.service';
import { Router } from '@angular/router';

@Component({
	selector: 'reingresar-dialog',
	templateUrl: 'reingresar-dialog.template.html',
})
export class ReingresarDialog {
	constructor(
		public dialogRef: MatDialogRef<ReingresarDialog>,
		public sessionService: SessionService,
		private router: Router,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {}
	username: string;
	password: string;
	error: string;

	onNoClick(): void {
		this.dialogRef.close();
	}

	desconectarse() {
		this.router.navigate(['/login']);
	}

	ingresar(): void {
		this.sessionService
			.reingresar(
				this.username,
				this.password,
				this.sessionService.getLastPerfil()
			)
			.subscribe({
				next: (res) => {
					if (res.Succeed) {
						this.dialogRef.close();
					} else {
						this.error = res.Message;
					}
				},
			});
	}
}
